import { PropsWithChildren } from "react";
import FlexContainer from "./flex-container";
import JumpingLama from "./jumping-lama";

export default function LoadingLamaContainer(props: PropsWithChildren<{
  isLoading: boolean
}>) {
  const { isLoading, children } = props
  
  if (isLoading) {
    return <FlexContainer centerVertically centerHorizontally>
      <JumpingLama />
    </FlexContainer>
  } else {
    return <>{children}</>
  }
}